import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslate } from 'react-redux-multilingual';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { storeToggle } from '../../../../actions/store';
import Store from '../../../utils/store';
import { storeDefault, dropdownDefault } from '../../MangoIcons'

class TopBar extends Component {
    constructor() {
        super()
        this.state = { matches: window.matchMedia("(max-width: 768px)").matches };
      }

    render() {
        const { translate, isAuth , headerText, presentURL, store_details} = this.props;
        return (
            <div className="top-header">
                <div className="container">
                    <div className="row" style={{padding:5}}>
                        <div className="col-lg-8 align-self-center">
                            <div className="header-contact">
                                <ul>
                                    <li style={{ display: "flex", justifyContent: "flex-end", fontSize: 12 }}>
                                        {headerText && headerText.length > 0 &&   headerText[0].APC_ELEMENT_CONTENT}
                                    </li>
                                </ul>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div className="dropdown-divider"></div>
               
                
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    // products: getVisibleproducts(state.data, state.filters),
    presentURL: state.tenant.presentURL,
    isAuth: state.user.isAuth,
    isOpen: state.store.isOpen,
    connection_id: state.tenant.connection_id,
    selectedStoreName: state.store.selectedStore && state.store.selectedStore.ASM_STORE,
    headerText:
    state.tenant && state.tenant.header_and_store_content &&state.tenant.header_and_store_content.filter(
      (item) => item.APC_ELEMENT_ID === "Header Description"
    ) || null,
    store_details: state.tenant.store_details,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { storeToggle },
        dispatch
    );

export default withTranslate(connect(
    mapStateToProps,
    mapDispatchToProps
)(TopBar));

// export default withTranslate(TopBar);